// extracted by mini-css-extract-plugin
module.exports = {"container":"Steps_container__1ZXII","wrapper":"Steps_wrapper__HsReW","headline":"Steps_headline__3Y7cd","text":"Steps_text__2it5R"};